import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { QuestionDto } from '../../../dto/justino/question.dto';
import { FormField } from '../../../dto/util/form-field';
import { QuestionService } from '../../../services/question.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { ModalNomDesComponent } from '../modal-nom-des/modal-nom-des.component';

@Component({
  selector: 'app-question-crud',
  templateUrl: './question-crud.component.html',
  styleUrl: './question-crud.component.scss',
})
export class QuestionCrudComponent implements OnInit {
  questionForm!: FormGroup;
  questions: QuestionDto[] = [];
  questionSets: string[] = [];
  allQuestions: QuestionDto[] = [];
  editingIndex: number | null = null;
  conDescripcion: boolean = false;

  formFields: FormField[] = [
    {
      name: 'set',
      label: 'Set',
      type: 'select',
      errorMessages: { required: 'La plantilla es requerida' },
    },
    {
      name: 'description',
      label: 'Descripción',
      type: 'textarea',
      errorMessages: { required: 'La descripción es requerida' },
    },
    {
      name: 'state',
      label: 'Estado',
      type: 'checkbox',
      errorMessages: { required: 'El estado es requerido' },
    },
    {
      name: 'options',
      label: 'Opciones',
      type: 'text',
      errorMessages: { required: 'Al menos una opción es requerida' },
    },
  ];

  // Define el formulario de subdominio
  @ViewChild(ModalNomDesComponent)
  modalND!: ModalNomDesComponent;

  constructor(
    private fb: FormBuilder,
    private questionService: QuestionService,
    private alertService: AlertaModalService
  ) {
    this.questionForm = this.fb.group({
      set: ['', Validators.required],
      description: ['', Validators.required],
      state: [true],
      options: this.fb.array([this.fb.control('', Validators.required)]),
    });
  }

  ngOnInit(): void {
    this.loadQuestions();
  }

  loadQuestions(): void {
    this.questionService.getAllQuestions('').subscribe({
      next: data => {
        this.allQuestions = data;
        console.log('data');
        console.log(data);
        this.questionSets = [...new Set(data.map(q => q.set))];
      },
      error: error => {
        this.alertService.error('Error', 'Error al cargar las preguntas');
      },
    });
  }

  abrirModalND() {
    setTimeout(() => {
      this.modalND.abrirCerrarModal();
    }, 500);
  }

  saveQuestions(): void {
    this.questionService.setQuestions(this.questions).subscribe(response => {
      this.alertService.exito(
        'Mensaje informativo',
        'Encuesta actualizada correctamente'
      );
    });
  }

  get options() {
    return this.questionForm.get('options') as FormArray;
  }

  addOption() {
    this.options.push(this.fb.control('', Validators.required));
  }

  removeOption(index: number) {
    this.options.removeAt(index);
  }

  addQuestion() {
    if (this.questionForm.valid) {
      const newQuestion: QuestionDto = {
        id:
          this.editingIndex !== null
            ? this.questions[this.editingIndex].id
            : Date.now(),
        ...this.questionForm.value,
      };

      if (this.editingIndex !== null) {
        this.questions[this.editingIndex] = newQuestion;
        this.editingIndex = null;
      } else {
        this.questions.push(newQuestion);
      }
      this.questionForm.get('description')?.setValue('');
      this.questionForm.get('state')?.setValue(true);
      this.options.clear();
    } else {
      this.questionForm.markAllAsTouched();
    }
  }

  editQuestion(index: number) {
    const question = this.questions[index];
    this.questionForm.patchValue({
      set: question.set,
      description: question.description,
      state: question.state,
      options: question.options,
    });
    this.editingIndex = index;
  }

  deleteQuestion(index: number) {
    this.questions.splice(index, 1);
  }

  crearPlantilla() {
    this.abrirModalND();
  }

  getErrorMessage(field: string): string | null {
    const control = this.questionForm.get(field);
    if (control?.invalid && control.touched) {
      const errorType = Object.keys(control.errors!)[0];
      return (
        this.formFields.find(f => f.name === field)?.errorMessages?.[
          errorType
        ] || 'Campo inválido'
      );
    }
    return null;
  }

  registrarPlantilla(dto: any) {
    let nombre = dto.nombre;
    this.questionSets.push(nombre);
    this.questionForm.get('set')?.setValue(nombre);
  }

  onSetChange() {
    const set = this.questionForm.get('set')?.value;
    this.questions = this.allQuestions.filter(q => q.set === set);
  }
}
